import { SolidStatusPill } from '@odo/shared-ui';
import React from 'react';
import { isInternalContent, type ContentAudience } from '../utils/audience';

const INTERNAL_TONE = 'bg-amber-50 text-amber-700 ring-1 ring-inset ring-amber-600/20';

interface InternalBadgeProps {
    audience?: ContentAudience;
    className?: string;
}

/** Marks staff-only content; external items render nothing. */
export const InternalBadge: React.FC<InternalBadgeProps> = ({ audience, className = '' }) =>
    isInternalContent({ audience }) ? (
        <SolidStatusPill
            value="internal"
            label="Internal"
            compact
            toneClassName={INTERNAL_TONE}
            dotClassName="bg-amber-500"
            className={`flex-shrink-0 ${className}`}
        />
    ) : null;

export default InternalBadge;
